/////////////////////////////////////////////////
/*
 * API URL
 * https://forkify-api.herokuapp.com/v2
 */
/////////////////////////////////////////////////

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '1b694359-953a-49b2-95c2-88025d1099f9';
export const MODAL_CLOSE_SEC = 2.5;
